import { History } from 'history';
import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { scrollToTop, getHotelSlug } from '../core/Const';
import { CMS } from '../shared/CMSData';
import { HotelBedData, SecurityData } from '../shared/index';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { SearchForm, CategoryHotels } from 'src/core';
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox';
import { momentWrapper, getAjaxhelper } from 'src/utils';

const AreaWedding = {
    "Canggu": "What was once a lazy surfer town has become one of the island’s most popular spots, with internationally acclaimed chefs and restaurants, countless cafes and shops, and a bustling nightlife scene.  The surf breaks and sunsets are legendary, and popular locales include Old Man’s, The Lawn, Echo Beach, and La Brisa.",
    "Berawa": "Between Seminyak and Canggu, Berawa has only recently become the place to be, thanks to the likes of Finn’s Beach Club and Finn’s Recreation Club.  The area is now a popular spot for locals and tourists, with a wide variety restaurants, cafes,and beachfront bars.",
    "Seminyak": " Long established as the trendiest, most fashionable spot in Bali, Seminyak is home to the island’s most famous beach clubs, resorts and restaurants.  Enjoy beachside brunches or sunsets at the W Hotel, Potatohead, or Ku De Ta. Or party the days or nights away at Motel Mexicola, Mrs Sippy Bali, La Favela… and more!",
    "Uluwatu": "Uluwatu is the most popular area for weddings in Bali, if not the world!  The stunning cliffs, ocean views and sunsets, are a recipe for the perfect weddings and photos. While staying here, visit the Karma Beach Club, El Kabron, Omnia Day Club, or Uluwatu Cliff House.",
    "Pererenan": "The beautiful scenery of rice paddies, sunsets and sea views make Pererenan one of the most popular locations for weddings in Bali. It’s peaceful, pristine and the venues are stunning.  There are not too many hotels in this area. Most groups stay at the hotels in Canggu (20 minutes away), so they are still close to shops and restaurants.  If you stay in Pererenan, it’s a nice escape, with private villas and smaller resorts on the beach.",
    "Legian / Kuta": " Kuta and Legian continue to be among the most popular places for Bali visitors, especially for families. There are hundreds of hotels for all budgets, with streets filled shops and restaurants, and a very lively nightlife scene.",
    "Jimbaran": "Jimbaran is a resort area of Bali, known for fishing and the famous sunset seafood BBQ’s every night. It’s just south of the airport, and home to the luxury resorts of the Four Seasons, AYANA, and Kayumanis Estate. Cuca is one of the island’s best restaurants, and Ibiza in Bali has become one of the more popular spots on the island.",
    "Keramas": "A wonderful escape from the crowds of western Bali, Keramas is located on the Eastern Coast, just north of Sanur. It’s a very popular location for surfers, the swells are legendary and the waters aren’t crowded. The Komune Resort is among the top places to stay in Bali, along with the many large beachfront villas, or to stay in nearby Sanur.",
    "Ubud": "",
    "Tabanan": "Tabanan is one of Bali’s most stunning and scenic locations, with expansive ocean and rice paddy views. Get away from it all with close friends and family, for a beautiful wedding in paradise. Tabanan is quite removed from the main areas of Bali.  For hotels, the WakaGangga is the closest resort, about 40 minutes away. Most wedding guests choose to stay in Canggu,and transport about an hour to the wedding."
};

export interface IndexWeddingProps extends BaseComponentProps {
    // id: string | number;
    lang: string;
    currency: string;
    data: any;
    pageSize: number;
    history?: History | any;
    slug: string;
    userLogin?: SecurityData.ApplicationUser | any;
    wishlistCount: (c: number) => any;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;
    initialFilter: HotelBedData.SearchFilter;
}
export interface IndexWeddingState extends BaseComponentState {
    data: CMS.CmsBlog;
    hotelDetail?: any;
    page: number;
    hotelCodes: number[];
    responKey?: string;
    hotels: HotelBedData.PagedHotelbedData | any;
    externalFilter: HotelBedData.ExternalFilter | any;
    currentFilter: HotelBedData.SearchFilter | any;
    error: boolean;
    errorMessage: string | any;
    requestingHotels: boolean;
    infoBoxOpen: boolean;
    indexMaker: number;
    formSubmit: {
        name: string,
        email: string,
        phone: string,
        msg: string,
        url: string
    };
}
const styles: any = [
    {
        featureType: 'poi.business',
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: 'transit',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }]
    }];
const MapWithAMarker = withScriptjs(withGoogleMap((props: any) => (
    <GoogleMap
        defaultZoom={13}
        defaultCenter={props.defaultCenter}
        defaultOptions={{ styles: styles }}
        onClick={
            () => {
                props.onToggleClose();
            }
        }
    >
        <Marker
            position={props.defaultCenter}
            icon={{ url: '/assets/images/wedding-pointer.png' }}
        />

        {props.hotels.map((hotels: any, index: any) => (
            <Marker
                position={{
                    lat: hotels.coordinates_latitude,
                    lng: hotels.coordinates_longitude
                }}
                icon={{ url: 'https://storage.googleapis.com/bali-hotel-images/Googlemap-pin-blue.png' }}
                onMouseOver={() => {
                    console.log("masuk sini");
                    props.onToggleOpen(index);
                }}
            >
                {props.infoBoxOpen && props.indexMaker === index && <InfoBox onCloseClick={props.onToggleOpen} options={{ closeBoxURL: ``, enableEventPropagation: true }}>
                    <div style={{ backgroundColor: `white`, width: 400 }}>
                        <div style={{ background: `url("${hotels.images[0].thumb}")`, backgroundSize: 'cover', backgroundPosition: 'center', width: 150, height: 150, float: 'left' }} />
                        <div style={{ width: 250, height: 150, padding: 10, marginLeft: 150 }}>
                            <span style={{ fontSize: 20 }}>{hotels.name} </span> <br />
                            <CategoryHotels size="small" star={hotels.category.simpleCode ? hotels.category.simpleCode : 1} />
                            <br />
                            <a href={`/${getHotelSlug(hotels.name, hotels.code)}`} target="_blank">View Detail</a>
                        </div>

                    </div>
                </InfoBox>}
            </Marker>
        ))}

    </GoogleMap>
)));

export class IndexWedding extends BaseComponent<IndexWeddingProps, IndexWeddingState> {

    timeout: any = null;

    constructor(props: IndexWeddingProps) {

        super(props);
        this.state = {
            data: props.data,
            page: 0,
            hotelCodes: [],
            hotels: null,
            externalFilter: null,
            requestingHotels: true,
            error: false,
            errorMessage: null,
            currentFilter: null,
            infoBoxOpen: false, indexMaker: -1,
            formSubmit: {
                name: '',
                email: '',
                phone: '',
                msg: '',
                url: `https://balihotelsandmore.com.au/${props.data.slug}`
            }
        };
        scrollToTop();
    }

    componentDidMount() {
        // fbq('trackCustom', 'ShareDiscount', {promotion: 'share_discount_10%'});
        if (window['fbq']) {
            window['fbq']('trackCustom', 'Wedding', {
                name: this.props.data.name,
                date: this.props.data.weddingDate,
                venue: this.props.data.weddingVenue,
                area: this.props.data.area,
                couponCode: this.props.data.couponCode
            });
        }
    }

    componentDidUpdate(prevProps: IndexWeddingProps, prevState: IndexWeddingState) {
        if (prevProps.slug !== this.props.slug) { scrollToTop(); }
    }

    getCmsContent: (x: any) => any = (x: any) => {
        return { __html: x };
    }

    onToggleOpen = (index: any) => {
        this.setState({ infoBoxOpen: true, indexMaker: index });
    }
    onToggleClose = () => {
        this.setState({ infoBoxOpen: false, indexMaker: -1 });
    }
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        // console.log("IndexWedding", this.props.data);
        let bgUrl = `url('${this.props.data.bannerUrl}')`;
        let defMapCenter: {
            lat: number;
            lng: number;
        } = { lat: 0, lng: 0 };
        if (this.props.data) {
            defMapCenter = {
                lat: this.props.data.lat,
                lng: this.props.data.lng,
            };
        }
        let treeButtonLink: any[] = [];
        let bannerLink = [
            {
                bannerUrl: 'https://storage.googleapis.com/bali-hotel-images/Early-Bird-Banner.jpg',
                Link: 'https://www.balivillasandmore.com/early-bird-villa-special-discount/',
                target: '_blank'
            },
            {
                bannerUrl: 'https://storage.googleapis.com/bali-hotel-images/Buck-Hens-Banner.jpg',
                Link: 'https://www.balitoursandmore.com/bali-bucks-and-hens-tours/',
                target: '_blank'
            },
            {
                bannerUrl: 'https://storage.googleapis.com/bali-hotel-images/Vip-Banner.jpg',
                Link: 'https://www.baliholidaysandmorevip.com/',
                target: '_blank'
            }
        ];
        for (let b of bannerLink) {
            treeButtonLink.push(
                <div className="col-md-4" style={{ marginTop: 30 }}>
                    <a href={`${b.Link}`} target={`${b.target}`}>
                        <img src={`${b.bannerUrl}`} width="100%" />
                    </a>
                </div>
            );
        }
        let dateWedding = momentWrapper(this.props.data.weddingDate);
        let isili = [];
        for (let h of this.props.data.hotels) {
            let htUrl = getHotelSlug(h.name, h.code);
            isili.push(
                <li>
                    <a href={`/${htUrl}`} target="_blank">{h.name}</a>
                </li>
            );
        }
        return (
            <div style={{ color: '#000' }}>

                <div
                    className="swiper-slide"
                    style={{
                        backgroundImage: bgUrl,
                        backgroundSize: 'cover', backgroundPosition: 'center'
                    }}
                >
                    <div className="container home-banner"  >
                        {}
                    </div>
                </div>
                <section className="container-fluid container-fullw  bg-white">
                    <div className="container">
                        <h3 style={{ textAlign: 'center', fontWeight: 800 }}>Congratulations {this.props.data.name}!</h3>
                        <br />
                        <p>We hope everyone is looking forward to their wedding on {dateWedding.format("MMMM DD YYYY")} at <strong> {this.props.data.weddingVenue} in {this.props.data.area}, Bali.</strong> </p>
                        <p>
                            We are here to help planning your holiday for {this.props.data.name}'s Bali wedding a breeze!
                            We have four sites dedicated to Bali travel:
                            <ul>
                                <li><a href="https://balihotelsandmore.com.au">Bali Hotels and More</a></li>
                                <li><a href="https://www.balivillasandmore.com/" target="_blank">Bali Villas and More</a></li>
                                <li><a href="https://www.balitoursandmore.com/" target="_blank">Bali Tours and More</a>  </li>
                                <li><a href="https://www.baliholidaysandmorevip.com/" target="_blank">Bali Holidays VIP</a></li>
                            </ul>
                            We help with travel recommendations and other great benefits, like free airport transfers, discounted travel insurance, free tours and activities for kids, and all bookings are automatically privy to our VIP network of services & savings.
                        </p>
                        <p style={{ textAlign: 'center' }}><img src="/assets/images/divider-clipart-word-2.png" style={{ margin: 'auto', height: 25 }} /></p>
                        <h3 style={{ textAlign: 'center', color: '#ff6cb2', fontWeight: 800 }}> {this.props.data.name} Bali Honeymoon Rewards</h3>
                        <p>We love our brides & grooms! Every booking from you goes towards rewards and savings for {this.props.data.name}, and their honeymoon hotel of their choice.  The more you book, the more wonderful and memorable their honeymoon will be! </p>
                        <p>
                            <strong><a href="https://balihotelsandmore.com.au">HOTELS</a></strong> - Hotels always book quickly during wedding season, so book your room with us now with just $1 deposit, with free cancellation!
                            - <a href="https://balihotelsandmore.com.au">https://balihotelsandmore.com.au</a>
                        </p>
                        <p>
                            <strong><a href="https://balivillasandmore.com">VILLAS</a></strong> - We have the largest selection of villas across Bali, on Bali Villas and More! Search by location, group size and budget to find your perfect private villa!
                            - <a href="https://balivillasandmore.com">https://balivillasandmore.com</a>
                        </p>
                        <p>
                            See below for our best selection of Bali villas, hotels, tours, and party ideas!    When booking, your the wedding’s booking code is:  <strong style={{ color: '#ff6cb2' }}>{this.props.data.couponCode}</strong>
                        </p>
                        <p style={{ textAlign: 'center' }}><img src="/assets/images/divider-clipart-word-2.png" style={{ margin: 'auto', height: 25 }} /></p>
                        <p>
                            <strong>We Support Bali Charities</strong>
                        </p>
                        <p>
                            Thanks for booking with us, every booking also supports Stella’s Child - an organization here in Bali that helps the underprivileged youth and orphans. They do this in many ways from food, shelter and most importantly job training skills. Your booking makes a difference in Bali!
                        </p> 
                        <p style={{ textAlign: 'center' }}><img src="/assets/images/divider-clipart-word-2.png" style={{ margin: 'auto', height: 25 }} /></p>
                        <br />
                        <p style={{ fontWeight: 800 }}> <a href="#special">CLICK HERE</a> TO SEE BELOW - OUR BEST ACTIVITIES, PARTY IDEAS & OUR VIP PROGRAM</p>
                        <a href="#footer" className="btn btn-primary">Need Help? Contact Us</a>
                    </div>
                </section>
                <section className="container-fluid container-fullw" style={{ backgroundImage: 'url("/assets/images/wedding-background.jpg")', backgroundSize: 'cover', paddingTop: 20, paddingBottom: 0 }}>
                    <div className="container">
                        <SearchForm
                            lang={this.props.lang}
                            showtitle={false}
                            style='horisontal'
                            count={15}
                            getHotels={this.props.getHotels}
                            externalFilter={{}}
                            filter={this.props.initialFilter}
                        /* key={btoa(JSON.stringify(this.props.initialFilter))} */
                        />
                    </div>
                </section>
                <section className="container-fluid container-fullw  bg-white" style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 0 }}>
                    <h3 style={{ fontWeight: 800, textAlign: 'center' }}>Our Bali Hotel Recommendations </h3>
                    <br /><br />
                    <div className="col-md-6">
                        <MapWithAMarker
                            defaultCenter={defMapCenter}
                            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAwKQXrpCCyjwljuwmbdhvxaeQ5dZi5DF8&v=3.exp&libraries=geometry,drawing,places"
                            loadingElement={<div style={{ height: `200px`, position: 'relative' }} ><div className='loader' /></div>}
                            containerElement={<div style={{ height: `450px` }} />}
                            mapElement={<div style={{ height: `100%` }} />}
                            defaultVisible={false}
                            defaultIcon={false}
                            hotels={this.props.data.hotels}
                            onToggleOpen={this.onToggleOpen}
                            infoBoxOpen={this.state.infoBoxOpen}
                            indexMaker={this.state.indexMaker}
                            onToggleClose={this.onToggleClose}
                        />
                    </div>
                    <div className="col-md-6" style={{ maxWidth: 600 }}>
                        <div style={{ margin: 30 }}>
                            <h4 style={{ fontWeight: 800, }}>{this.props.data.weddingVenue} is located in {this.props.data.area}</h4>
                            {AreaWedding[this.props.data.area]}
                            <p>We have selected our top choices for hotel accommodations that are reasonably close to the venue. </p>
                            <ul>
                                {isili}
                            </ul>
                            <p>Select your your hotel with dates, and book now for just $1, with payment two weeks before you arrive! And, if the options above don’t work, search here for more options - click below for our best deals across the island.</p>
                            <p>
                                Need more options? We have over 3000 Bali hotels and villas - click below for our best deals across the island
                            </p> 
                            <a href="/balis-best-wedding-hotels" className="btn btn-primary wed-bt1-link1" target="_blank" style={{ marginTop: 10, marginLeft: 15  }}>Bali’s Best Wedding Hotels</a>
                            <a href="https://www.balivillasandmore.com/early-bird-villa-special-discount/" className="btn btn-primary  wed-bt1-link2" style={{ marginTop: 10, marginLeft: 15 }}>Bali Best Villas</a>
                        </div>
                    </div>
                </section>
                <section className="container-fluid container-fullw bg-white" id="special">
                    <div className="container">
                        <h4 style={{ fontWeight: 800, textAlign: 'center' }}><a href="https://www.balitoursandmore.com/bali-bucks-and-hens-tours/" target="_blank">Activities, Parties and Tours</a></h4>
                        <p>While in Bali, take some time to explore the countless wonders the Island of the Gods has to offer!  We have over 100 tours and activities for you to enjoy all across the island, from cultural to adventure sports and beautiful beaches. -
                            <a href="https://www.balitoursandmore.com/" target="_blank">https://www.balitoursandmore.com</a>
                        </p>

                        <p>How are the happy couple celebrating their last days of being single?   See our hand-selected options for groups for the best Bucks and Hens parties and outings. -
                            <a href=" https://www.balitoursandmore.com/bali-bucks-and-hens-tours/" target="_blank"> https://www.balitoursandmore.com/bali-bucks-and-hens-tours</a>
                        </p>
                        <p style={{ textAlign: 'center' }}><img src="/assets/images/divider-clipart-word-2.png" style={{ margin: 'auto', height: 25 }} /></p>
                        <h4 style={{ fontWeight: 800, textAlign: 'center' }}><a href="https://www.baliholidaysandmorevip.com/" target="blank">You are a BALI HOLIDAYS and MORE VIP!</a></h4>
                        <p>We have partnered with some of the most popular services and venues on the island to treat brides, grooms and their guests like VIPS!  See our wide selection of benefits from beauty treatments and touch ups, to discounts and access to the best beach clubs and restaurants.
                        </p>
                        <p>All of our wedding guests and couples who book with us get the VIP treatment! You will not find this with any other Bali travel provider.  <a href=" https://www.baliholidaysandmorevip.com/ " target="_blank">https://www.baliholidaysandmorevip.com</a>   </p>

                        {treeButtonLink}
                    </div>
                </section>
                <section className="container-fluid container-fullw" style={{ background: 'url(/assets/images/wedding-bg.jpg)', backgroundPosition: 'center', backgroundSize: 'cover' }}>
                    <div className="container" style={{ textAlign: 'center' }}>
                        <h3 style={{ color: "#fff" }}>Get in touch with us, we are in Bali! </h3>
                        <h4 style={{ color: "#fff" }}>To contact one of our group and wedding reservations agents, use the form below:</h4>
                        <br /><br />
                        <form id="contactForm" onSubmit={this.formSubmit} style={{ maxWidth: 600, margin: 'auto' }}>
                            <div className="row">
                                <div className="form-group">
                                    <div className="col-md-12">
                                        <label style={{ color: '#fff', textAlign: 'left' }}> Your name <span className="symbol required" /> </label>
                                        <input
                                            required={true}
                                            type="text"
                                            data-msg-required="Please enter your name."
                                            className="form-control"
                                            value={this.state.formSubmit.name}
                                            onChange={
                                                (evt: any) => {
                                                    let formSubmit = this.state.formSubmit;
                                                    formSubmit.name = evt.target.value;
                                                    this.setState({ formSubmit });
                                                }
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="form-group">
                                    <div className="col-md-6">
                                        <label style={{ color: '#fff', textAlign: 'left' }}> Email address <span className="symbol required" /> </label>
                                        <input
                                            required={true}
                                            type="email"
                                            data-msg-required="Please enter your email address."
                                            data-msg-email="Please enter a valid email address."
                                            className="form-control"
                                            value={this.state.formSubmit.email}
                                            onChange={
                                                (evt: any) => {
                                                    let formSubmit = this.state.formSubmit;
                                                    formSubmit.email = evt.target.value;
                                                    this.setState({ formSubmit });
                                                }
                                            }
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label style={{ color: '#fff', textAlign: 'left' }}> Phone / Whatsapp </label>
                                        <input
                                            required={true}
                                            type="text"
                                            data-msg-required="Please enter phone number."
                                            className="form-control"
                                            value={this.state.formSubmit.phone}
                                            onChange={
                                                (evt: any) => {
                                                    let formSubmit = this.state.formSubmit;
                                                    formSubmit.phone = evt.target.value;
                                                    this.setState({ formSubmit });
                                                }
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="form-group">
                                    <div className="col-md-12">
                                        <label style={{ color: '#fff', textAlign: 'left' }}> Message <span className="symbol required" /> </label>
                                        <textarea
                                            required={true}
                                            data-msg-required="Please enter your message."
                                            className="form-control"
                                            value={this.state.formSubmit.msg}
                                            onChange={
                                                (evt: any) => {
                                                    let formSubmit = this.state.formSubmit;
                                                    formSubmit.msg = evt.target.value;
                                                    this.setState({ formSubmit });
                                                }
                                            }
                                        />
                                        <input type="hidden" value={this.props.data.slug} id="from_url" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <button data-caption-delay="900" type="submit" data-caption-class="fadeIn" className="btn btn-primary margin-top-15 opacity-0 btn-wide btn-scroll btn-scroll-top fa-arrow-right animated fadeIn" >
                                        <span>Enquire Now</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                        <a href="https://wa.me/+6287860006919" style={{ display: "none" }} className="btn btn-primary" target="_blank">Call Free on Whatsapp on +6287860006919</a>
                    </div>
                </section>
            </div>
        );
    }

    formSubmit = (event: any) => {
        event.preventDefault();
        let nameSender = this.state.formSubmit.name;
        let contentClient = "";
        contentClient = "<h3>Thank you for booking your Bali hotel with Bali Hotels and More!</h3>";
        contentClient += `<p>You&rsquo;ve made a great choice; we&rsquo;re with you every step of the way to ensure hassle free holiday planning and that you have a great time in Bali. You&rsquo;ve chosen the Book Now and Pay Later option - this is a great way of making your holiday more affordable. You&rsquo;ll avoid the hidden costs of banking fees and poor currency exchange rates which you can add 5 - 10% to the cost of your accommodation when you pay with your card at the hotel. The Book Now and Pay Monthly option which you&rsquo;ve chosen includes a $1 deposit and then final payment is due 2 weeks prior to arrival in Bali or before the cancellation date of the hotel you have chosen Full terms and conditions are here &nbsp;<a href="https://www.balihotelsandmore.com.au/terms-of-use" target="_blank">https://www.balihotelsandmore.com.au/terms-of-use</a></p>`;
        contentClient += "<p>Our team will now check to ensure we have the option available for the room you want. We will then give you a quick call to confirm your exact requirements. Then we send an invoice for $1 deposit. Once you pay then we then issue and email your hotel vouchers.</p>";
        contentClient += "<p>We would also like to take this opportunity to thank you on behalf of our Bali charities we support including:</p>";
        contentClient += `<p>Soleman Bali - &nbsp;<a href="https://www.solemen.org/">https://www.solemen.org</a> &nbsp;</p>`;
        contentClient += `<p>Stella&rsquo;s Child - <a href="https://www.stellaschild.org/">https://www.stellaschild.org/</a></p>`;
        contentClient += "<p>Your booking really does make a difference here in Bali!</p>";
        contentClient += "<p>We look forward to speaking to you within the next 24 - 48 hours.</p>";
        let contentAdmin = "";
        contentAdmin += `Name : ${this.state.formSubmit.name} <br>`;
        contentAdmin += `email : ${this.state.formSubmit.email} <br>`;
        contentAdmin += `phoneNumber : ${this.state.formSubmit.phone} <br>`;
        contentAdmin += `message : ${this.state.formSubmit.msg} <br><br><br>`;
        contentAdmin += `URL : https://balihotelsandmore.com.au/bali-weddings/${this.props.data.slug} <br><br>`;
        let subject = "[Bali Hotels and More] Wedding Enquire " + this.props.data.name;
        let emailSender = this.state.formSubmit.email;

        let dataSendEmail = {
            nameSender: nameSender,
            contentClient: (contentClient),
            contentAdmin: (contentAdmin),
            emailSender: emailSender,
            subject: subject
        };
        getAjaxhelper().post("/dynamics/email-sender-bham/enquery", dataSendEmail).then(
            x => {
                this.props.history.push('/settlement-thankyou');
            }
        ).catch(
            exc => {
                console.log(exc);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/cms/IndexWedding.tsx